// extracted by mini-css-extract-plugin
export var boldText = "_7b-4";
export var checkboxContainer = "_7b-6";
export var closeIcon = "_7b-i";
export var container = "_7b-0";
export var drawer = "_7b-8";
export var drawerContent = "_7b-9";
export var extraSmallText = "_7b-5";
export var fulfillmentGroupTable = "_7b-e";
export var largeText = "_7b-3";
export var loadingSpinnerContainer = "_7b-j";
export var mediumText = "_7b-2";
export var narrow = "_7b-f";
export var notificationLink = "_7b-l";
export var packageCheckIconContainer = "_7b-7";
export var slideoutHeaderActions = "_7b-g";
export var slideoutHeaderActionsShifted = "_7b-h";
export var slideoutHeaderContainer = "_7b-a";
export var slideoutModal = "_7b-c";
export var stickyHeaderWrapper = "_7b-b";
export var table = "_7b-k";
export var tableContainer = "_7b-d";
export var tertiaryText = "_7b-1";